/**
 * DevExtreme (esm/__internal/scheduler/utils/options_validator/core/validator_rules.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const createValidatorRule = (name, ruleFunc) => {
  Object.defineProperty(ruleFunc, "name", {
    value: name,
    writable: false
  });
  return ruleFunc;
};